import { v4 as uuid } from 'uuid';

export const addSelectedItem = async (store, skuOrUPC, mode, lineItemCurrentPrice) => {
  store.setState({ requestStatus: 'LOADING' });

  let selectedItem;

  const availableItem = store.state.availableItems.find(item => item.sku.includes(skuOrUPC));

  if (mode === 'processing' && availableItem && availableItem.sku.includes('MK')) {
    store.setState({ requestStatus: 'INITIAL' });
    return store.actions.notification.showDialog(
      store.state.text.store.error_marketplace_title,
      store.state.text.store.error_marketplace
    );
  }

  if (availableItem) {
    if (mode === 'price-match') {
      const priceHistory = await store.actions.db.getPriceHistory(skuOrUPC, availableItem.channel);
      selectedItem = {
        ...availableItem,
        line_item_current_price: parseFloat(lineItemCurrentPrice),
        validated: true,
        requested_price: null,
        price_history: priceHistory,
        member_type: 'none',
        price_match_type: 'internal',
        discount: false,
        competitor_url: ''
      };
    } else {
      selectedItem = { ...availableItem, validated: true };
    }
  } else {
    const skuObj = await store.actions.db.getSkuFromUPC(skuOrUPC);
    if (skuObj) {
      const availableItemFromUPC = store.state.availableItems.find(item => item.sku.includes(skuObj.sku));

      if (mode === 'processing' && availableItem && availableItem.sku.includes('MK')) {
        store.setState({ requestStatus: 'INITIAL' });
        return store.actions.notification.showDialog(
          store.state.text.store.error_marketplace_title,
          store.state.text.store.error_marketplace
        );
      }

      if (availableItemFromUPC) {
        selectedItem = { ...availableItemFromUPC, validated: true };
      } else {
        selectedItem = {
          title: skuObj.handle,
          sku: skuObj.sku,
          uniq_id: uuid(),
          validated: false,
          vendor: skuObj.vendor
        };

        store.actions.notification.showMessage(store.state.text.store.item_unavailable, 'error');
      }
    } else {
      store.setState({ requestStatus: 'SUCCESS' });
    }
  }

  if (selectedItem) {
    const updatedAvailableItems = [...store.state.availableItems];

    if (selectedItem.validated) {
      updatedAvailableItems.splice(
        updatedAvailableItems.findIndex(item => item.uniq_id === selectedItem.uniq_id),
        1
      );
    }

    store.setState({
      availableItems: updatedAvailableItems,
      selectedItems: [selectedItem, ...store.state.selectedItems],
      requestStatus: 'SUCCESS'
    });
  }
};

export const removeSelectedItem = (store, item) => {
  const updatedSelectedItems = [...store.state.selectedItems];
  updatedSelectedItems.splice(
    updatedSelectedItems.findIndex(el => el.uniq_id === item.uniq_id),
    1
  );

  const updatedAvailableItems = [...store.state.availableItems];
  if (item.validated) {
    updatedAvailableItems.push(item);
  }

  store.setState({
    availableItems: updatedAvailableItems,
    selectedItems: updatedSelectedItems
  });
};

export const updateValidatedItem = async (store, item, orderNb, orderChannel) => {
  const order = await store.actions.db.getOrder(orderNb, orderChannel);

  if(store.state.orders.map(o => o.order_number).includes(order.order_number) ||
  !order.line_items.some( li => li.sku === item.sku)) {
    store.actions.notification.showMessage(store.state.text.store.item_unavailable, 'error');
    return false;
  }

  store.actions.utils.updateOrderStore(order);

  const updatedSelectedItems = [...store.state.selectedItems];
  store.setState({ selectedItems: [] });

  store.setState({ requestStatus: 'LOADING' });

  if (order) {
    const returns = await store.actions.db.getReturns({
      key: 'order',
      value: orderNb
    });
    returns && store.actions.items.setAvailableItems('processing', orderChannel);

    const updatedAvailableItems = [...store.state.availableItems];

    if (updatedAvailableItems.find(el => el.sku === item.sku)) {
      const validatedItemIndex = updatedAvailableItems.findIndex(
        el => el.sku === item.sku && el.order_name === orderNb
      );

      updatedAvailableItems[validatedItemIndex].validated = true;
      updatedSelectedItems.unshift(updatedAvailableItems[validatedItemIndex]);
      updatedSelectedItems.splice(
        updatedSelectedItems.findIndex(el => el.uniq_id === item.uniq_id),
        1
      );
      updatedAvailableItems.splice(validatedItemIndex, 1);

      store.setState({
        availableItems: updatedAvailableItems,
        selectedItems: updatedSelectedItems,
        requestStatus: 'SUCCESS'
      });
      store.actions.notification.hideMessage();
    } else {
      store.actions.notification.showMessage(store.state.text.store.item_unavailable_in_order, 'error');
      store.setState({
        requestStatus: 'SUCCESS',
        selectedItems: updatedSelectedItems,
        orders: store.state.orders.filter(order => order.order_number !== +orderNb)
      });
    }
  } else {
    store.actions.notification.showMessage('No order found.', 'error');
    store.setState({ requestStatus: 'SUCCESS', selectedItems: updatedSelectedItems });
  }
};

export const toggleItemRefundException = (store, e, itemId) => {
  e.preventDefault();
  const updatedSelectedItems = [...store.state.selectedItems];
  const selectedItemIndex = updatedSelectedItems.findIndex(el => el.uniq_id === itemId);
  updatedSelectedItems[selectedItemIndex].refund_exception = !updatedSelectedItems[selectedItemIndex].refund_exception;

  store.setState({ selectedItems: updatedSelectedItems });
};

// AVAILABLE ITEMS FUNCTIONS:
export const setAvailableItems = async (store, mode, channel) => {
  const availableItemsLength = store.state.availableItems.length;

  let ordersItems = formatAvailableOrdersItems(store, mode);
  ordersItems = filterBySelectedSeller(store, ordersItems);
  ordersItems = filterOutSelectedItems(store.state.selectedItems, ordersItems);

  let returnObjects;
  if (channel) {
    returnObjects = store.state.returns.filter(returnObj => returnObj.channel === channel);
  } else {
    returnObjects = store.state.returns;
  }

  if (mode !== 'price-match' && returnObjects.length > 0) {
    returnObjects.forEach(returnObj => {
      if (mode === 'return-creating') {
        removeUnavailableItems(returnObj, ordersItems);
      } else if (mode === 'processing') {
        if (returnObj.status === 'closed' || returnObj.status === 'processing') {
          removeUnavailableItems(returnObj, ordersItems);
        }
      }
    });
    store.setState({ availableItems: ordersItems });
  } else if (mode === 'price-match') {
    const availableItems = setPriceMatchAvailableItems(ordersItems, store.state.orders[0]);
    store.setState({ availableItems });
  } else {
    store.setState({ availableItems: ordersItems });
  }

  const hasEmptyObj =
    returnObjects.length > 0 && returnObjects.find(returnObj => returnObj.received_at && returnObj.items.length === 0);

  if (availableItemsLength === ordersItems.length && !hasEmptyObj) {
    store.actions.notification.showMessage(store.state.text.store.error_no_sku_available, 'error');
  }

  if (!store.state.selectedSeller) await setSellersOptions(store);

  return;
};

function setPriceMatchAvailableItems(ordersItemsMinusSelectedItems, order) {
  const refunds = order.refunds;
  if (refunds.length > 0) {
    const lineItemsRefunds = refunds.map(refund => refund.refund_line_items).flat();

    lineItemsRefunds.forEach(refund => {
      const item = ordersItemsMinusSelectedItems.find(
        el => el.line_item_id.toString() === refund.line_item_id.toString()
      );
      item.quantity_ordered -= refund.quantity;
    });
  }
  return ordersItemsMinusSelectedItems.filter(item => item.quantity_ordered > 0);
}

function toFixed(num, precision) {
  return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
}

function setAltidollarsRefundField(store, order, paidPriceBeforeMembershipAndCoupon, originalItemPrice) {
  const orderCreationDate = order.created_at.split('T')[0];
  const now = new Date();
  const orderDate = new Date(order.created_at);
  const orderDatePlusBuffer = new Date(orderDate.setTime(orderDate.getTime() + 36 * 60 * 60 * 1000));
  const isOrderCancellation = now <= orderDatePlusBuffer;
  const isInstalmentsGateway = order.transactions.some(
    transaction =>
      (transaction.gateway === 'paybright' || transaction.gateway === 'sezzle') && transaction.status === 'success'
  );

  if (store.state.currentCampaign && !isOrderCancellation && store.state.channels[order.channel].store_credits_policy && !isInstalmentsGateway) {
    const { starting_at, ending_at, threshold } = store.state.currentCampaign;
    const startingDate = starting_at ? starting_at.split('T')[0] : null;
    const endingDate = ending_at ? ending_at.split('T')[0] : null;
    const isAltiRefundCheck = (1 - paidPriceBeforeMembershipAndCoupon / originalItemPrice) * 100 >= Number(threshold);

    if (startingDate && !endingDate && orderCreationDate >= startingDate) {
      return isAltiRefundCheck;
    } else if (startingDate && endingDate && orderCreationDate >= startingDate && orderCreationDate <= endingDate) {
      return isAltiRefundCheck;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function addReturnObjectDataToItem(store, formattedAvailableItem, order) {
  const returnObj = store.state.returns.find(
    el => el.order_name === order.order_number.toString() && (el.status === 'open' || el.status === 'received')
  );
  const returnObjItems = returnObj ? returnObj.items : null;
  const matchedItem = returnObjItems
    ? returnObjItems.find(el => el.line_item_id.toString() === formattedAvailableItem.line_item_id.toString())
    : null;

  const updatedFormattedAvailableItem = JSON.parse(JSON.stringify(formattedAvailableItem));

  if (matchedItem) {
    Object.keys(matchedItem).forEach(key => {
      if (updatedFormattedAvailableItem[key] !== undefined) {
        updatedFormattedAvailableItem[key] = matchedItem[key];
      }
    });
    if (returnObj && returnObj.bypass_altidollars_refund_campaign) {
      updatedFormattedAvailableItem.altidollar_refund = false;
    }
    return updatedFormattedAvailableItem;
  } else {
    if (returnObj && returnObj.bypass_altidollars_refund_campaign) {
      formattedAvailableItem.altidollar_refund = false;
    }
    return formattedAvailableItem;
  }
}

function formatAvailableItem(store, item, order) {
  const paidPrice = Number(toFixed(item.pre_tax_price / item.quantity, 2));
  const paidPriceBeforeMembershipAndCoupon = Number(item.price);
  const originalItemPrice = item.original_price ? Number(item.original_price) : paidPrice;

  const isInstalmentsGateway = order.transactions.some(
    transaction =>
      (transaction.gateway === 'paybright' || transaction.gateway === 'sezzle') && transaction.status === 'success'
  );

  const formattedAvailableItem = {
    altidollar_refund: setAltidollarsRefundField(store, order, paidPriceBeforeMembershipAndCoupon, originalItemPrice),
    channel: order.channel,
    image_src: item.image_src ? item.image_src : '',
    line_item_id: item.id.toString(),
    order_name: order.order_number.toString(),
    original_price: originalItemPrice,
    paid_price: paidPrice,
    quantity_ordered: item.quantity,
    refund_exception: false,
    restock_exception: false,
    reason: null,
    sale_price: paidPriceBeforeMembershipAndCoupon,
    sku: item.sku,
    title: item.title,
    uniq_id: uuid(),
    variant_title: item.variant_title,
    vendor: item.vendor
  };

  if (isInstalmentsGateway) formattedAvailableItem.isInstalmentsGateway = true;

  const formattedAvailableItemPlusData = addReturnObjectDataToItem(store, formattedAvailableItem, order);

  return formattedAvailableItemPlusData;
}

function formatAvailableOrdersItems(store, mode) {
  return store.state.orders
    .map(order => {
      const lineItems = order.line_items;

      return lineItems
        .map(item => {
          const quantityAvailableToReturn = item.quantity - item.fulfillable_quantity;

          if (quantityAvailableToReturn === 1 || mode === 'price-match') {
            return formatAvailableItem(store, item, order);
          } else if (quantityAvailableToReturn > 1) {
            const items = [];
            for (let i = 0; i < quantityAvailableToReturn; i++) {
              items.push(formatAvailableItem(store, item, order));
            }
            return items;
          } else {
            return null;
          }
        })
        .flat();
    })
    .flat();
}

function removeUnavailableItems(returnObj, ordersItems) {
  returnObj.items.forEach(item => {
    const i = ordersItems.findIndex(
      orderItem => orderItem.order_name === returnObj.order_name && item.sku === orderItem.sku
    );
    ordersItems.splice(i, 1);
  });
}

function filterBySelectedSeller(store, ordersItems) {
  let availableChannelNames = Object.keys(store.state.channels).map(channel_abbr => store.state.channels[channel_abbr].channel_name_en);
  if (store.state.selectedSeller) {
    if (availableChannelNames.indexOf(store.state.selectedSeller) > -1) {
      ordersItems = ordersItems.filter(item => !item.sku.includes('MK'));
    } else {
      const sellerBrands = store.state.sellers.find(seller => seller.seller_name === store.state.selectedSeller)
        .seller_brands;

      ordersItems = ordersItems.filter(item => item.sku.includes('MK') && sellerBrands.indexOf(item.vendor) > -1);
    }
  }
  return ordersItems;
}

function filterOutSelectedItems(selectedItems, ordersItems) {
  return ordersItems.filter(item => {
    if (selectedItems.some(el => el.validated && el.order_name === item.order_name && el.sku === item.sku)) {
      return null;
    } else {
      return item;
    }
  });
}

async function setSellersOptions(store) {
  // To set AS selling brands
  let brands = store.state.availableItems
    .filter(item => !item.sku.includes('MK'))
    .map(nonMkItem => nonMkItem.channel);

  brands = [...new Set(brands)];
  let channels = store.state.channels;
  Object.keys(channels).forEach((channel_abbr) => {
    if (brands.indexOf(channel_abbr) > -1) {
      store.setState({ sellers: [{ seller_brands: [channels[channel_abbr].channel_name_en], seller_name: channels[channel_abbr].channel_name_en }] });
    }
    return;
  });
  // To check Sellers for MKitems (if any)
  let mk_shop_ids = store.state.availableItems.filter(item => item.sku.includes('MK')).map(item => item.sku.split('_')[2]);
  
  if (mk_shop_ids.length > 0) {
    await store.actions.db.getMarketplaceSellers(mk_shop_ids);
  }
  // To set a seller directly in case : single seller for all items in the return obj

  if (store.state.sellers.length === 1) {
    store.state.selectedSeller = store.state.sellers[0].seller_name;
  }
  return;
}

export const filterBySeller = (store, sellerName) => {
  let filteredItems;

  let availableChannelNames = Object.keys(store.state.channels).map(channel_abbr => store.state.channels[channel_abbr].channel_name_en);
  if (availableChannelNames.indexOf(sellerName) > -1) {
    filteredItems = store.state.availableItems.filter(item => !item.sku.includes('MK'));
  } else {
    const sellerBrands = store.state.sellers.find(seller => seller.seller_name === sellerName).seller_brands;
    filteredItems = store.state.availableItems.filter(item => {
      return sellerBrands.indexOf(item.vendor) > -1 && item.sku.includes('MK');
    });
  }

  store.setState({ availableItems: filteredItems, selectedSeller: sellerName });
};

// Cerberus desktop only

export const updateItem = (store, item, key, value) => {
  const updatedSelectedItems = [...store.state.selectedItems];
  const itemIndex = updatedSelectedItems.findIndex(el => el.uniq_id === item.uniq_id);
  updatedSelectedItems[itemIndex][key] = value;

  if (key === 'reason' && value._id === 7) {
    updatedSelectedItems[itemIndex].refund_exception = true;
  }

  store.setState({ selectedItems: updatedSelectedItems });
  if (key === 'reason') {
    setWarrantyNotes(store);
    setDOANotes(store);
  }
};

function setWarrantyNotes(store) {
  if (store.state.selectedItems.some(item => item.reason && item.reason._id === 10)) {
    store.setState({ receptionNote: store.state.text.store.warranty });
    store.setState({ prepaidLabelNote: 'WARRANTY-GARANTIE' });
    store.setState({ restockingFeeException: true });
  } else {
    store.setState({
      receptionNote: store.state.receptionNote.replace(store.state.text.store.warranty, '')
    });
    store.setState({
      prepaidLabelNote: store.state.prepaidLabelNote.replace('WARRANTY-GARANTIE', '')
    });
    store.setState({ restockingFeeException: false });
  }
}

function setDOANotes(store) {
  if (store.state.selectedItems.some(item => item.reason && item.reason._id === 7)) {
    store.setState({ receptionNote: store.state.text.store.doa });
    store.setState({ prepaidLabelNote: 'DOA' });
    store.setState({ restockingFeeException: true });
  } else {
    store.actions.utils.updateStateProperty(
      'receptionNote',
      store.state.receptionNote.replace(store.state.text.store.doa, '')
    );
    store.actions.utils.updateStateProperty('prepaidLabelNote', store.state.prepaidLabelNote.replace('DOA', ''));
    store.setState({ restockingFeeException: false });
  }
}
